import { useState } from 'react'

import { Modal } from '@material-ui/core'
import { withLocalize } from 'react-localize-redux'
import styles from './ReportCalibrationModalContainer.module.scss'
import ReportCalibrationModal from '../components/ReportCalibrationModalForm'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { requestFile, downloadPdfFromBase64Response, downloadPdfFromPayload } from 'utils/request'
import { getUser } from 'common/selectors/user'
import { showSnackbar } from 'common/actions/snackbar'

const LONG_CALIBRATION_DEVICE_THRESHOLD = 10

const ReportCalibrationModalContainer = props => {
  const [open] = useState(true)
  const { hideModal, systems, user, userEmail, showSnackbar } = props
  const systemsByGroup = _.groupBy(systems, 'group')
  const [emailPending, setEmailPending] = useState(null)
  const handleSubmit = async data => {
    const now = new Date()
    if (props.isSubmitting) return
    let submitData = {
      name: data.name,
      systems: data.deviceId,
      reportType: data.reportType,
      language: user.toJS().language,
      todaysDate:
        user.toJS().language === 'es'
          ? now.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }) +
            ' ' +
            now.toLocaleTimeString('es-ES', {
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false
            })
          : now.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }) +
            ' ' +
            now.toLocaleTimeString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false
            })
    }
    if (data.notificationEmail) {
      submitData.notificationEmail = data.notificationEmail
    }
    try {
      const response = await requestFile(`reports/calibrationReport/`, {
        method: 'POST',
        data: {
          ...submitData
        }
      })

      if (!response || response === 413) return

      const contentType = response.headers.get('content-type') || ''
      let payload = null
      if (contentType.includes('application/json')) {
        payload = await response.json()
        if (payload?.status === 'email-pending') {
          setEmailPending({
            email: payload.email,
            threshold: payload.threshold
          })
          return
        }
        if (payload?.reult === 'worked' && payload?.pdf) {
          await downloadPdfFromPayload(payload, submitData.name)
          hideModal()
          return
        }
      }

      const worked = response.headers.get('reult')
      if (worked === 'worked') {
        await downloadPdfFromBase64Response(response, submitData.name, payload)
        hideModal()
      }
    } catch {
      showSnackbar('snackbar.whoops')
    }
  }

  return (
    <Modal
      open={open}
      onClose={hideModal}
      arial-labelledby='simple-modal-title'
      arial-desccribedby='simple-modal-description'
    >
      <div className={styles.modalContainer}>
        <ReportCalibrationModal
          {...props}
          systems={systems}
          systemsByGroup={systemsByGroup}
          onSubmit={handleSubmit}
          emailPending={emailPending}
          userEmail={userEmail}
          longCalibrationThreshold={LONG_CALIBRATION_DEVICE_THRESHOLD}
          onGenerateAnother={() => setEmailPending(null)}
        />
      </div>
    </Modal>
  )
}
ReportCalibrationModalContainer.propTypes = {
  hideModal: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  showSnackbar: PropTypes.func.isRequired
}

const mapStateToProps = state => {
  const user = getUser(state)
  return {
    userEmail: user ? user.get('email') : ''
  }
}

const mapActionsToProps = {
  showSnackbar
}

export default withLocalize(
  connect(mapStateToProps, mapActionsToProps)(ReportCalibrationModalContainer)
)
